module.exports = __webpack_public_path__ + "img/shadow.16a6184e.png";